/* CollapsibleSection — reusable секция със заглавие и collapse toggle.
 * Запомня състоянието в localStorage по storageKey.
 */
import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";

export default function CollapsibleSection({
  title,
  storageKey,
  defaultOpen = true,
  rightSlot,
  testId,
  children,
}) {
  const { isDark } = useTheme();
  const [open, setOpen] = useState(() => {
    if (typeof window === "undefined") return defaultOpen;
    const saved = localStorage.getItem(`hi-section:${storageKey}`);
    return saved == null ? defaultOpen : saved === "1";
  });

  useEffect(() => {
    if (storageKey) {
      try { localStorage.setItem(`hi-section:${storageKey}`, open ? "1" : "0"); } catch {}
    }
  }, [open, storageKey]);

  return (
    <section data-testid={testId || `section-${storageKey || "anon"}`}>
      <div className="flex items-center gap-2 mb-3">
        <button
          onClick={() => setOpen((o) => !o)}
          data-testid={`section-toggle-${storageKey || "anon"}`}
          className={`flex items-center gap-2 text-xs uppercase tracking-wider font-bold transition-colors ${
            isDark ? "text-slate-400 hover:text-slate-200" : "text-slate-500 hover:text-slate-900"
          }`}
        >
          {open ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
          {title}
        </button>
        {rightSlot && <div className="ml-auto">{rightSlot}</div>}
      </div>
      {open && <div className="animate-in fade-in-50 duration-150">{children}</div>}
    </section>
  );
}
